/* -disable no-use-before-define */
// Performance Status

export const performanceStatus = {
  NOT_INFORMED: 0,
  ONTIME: 1,
  LATE_RISK: 2,
  LATE: 3,
  CANCELLED: 4,
};

export const getPerformanceStatusLabel = code => {
  switch (code) {
    case performanceStatus.NOT_INFORMED:
      return 'Sem dados de performance';
    case performanceStatus.ONTIME:
      return 'No prazo';
    case performanceStatus.LATE_RISK:
      return 'Risco de atraso';
    case performanceStatus.LATE:
      return 'Atrasado';
    case performanceStatus.CANCELLED:
      return 'Cancelado';
    default:
      return '';
  }
};

export const getPerformanceStatusClass = code => {
  switch (code) {
    case performanceStatus.NOT_INFORMED:
      return 'not-informed';
    case performanceStatus.ONTIME:
      return 'ontime';
    case performanceStatus.LATE_RISK:
      return 'late-risk';
    case performanceStatus.LATE:
      return 'late';
    case performanceStatus.CANCELLED:
      return 'cancelled';
    default:
      return '';
  }
};

export const getPerformanceStatusIcon = code => {
  switch (code) {
    case performanceStatus.NOT_INFORMED:
      return 'consolidation';
    case performanceStatus.ONTIME:
      return 'check_circle_checked';
    case performanceStatus.LATE:
    case performanceStatus.LATE_RISK:
      return 'warning';
    case performanceStatus.CANCELLED:
      return 'cancel';
    default:
      return '';
  }
};

// Service Not Contracted

const SERVICE_NOT_CONTRACTED_CODE = 99;

export const isServiceNotContracted = code =>
  code === SERVICE_NOT_CONTRACTED_CODE;

// WMS Status

export const wmsStatus = {
  WAITING_WAVE: 0,
  WAITING_SEPARATION: 1,
  SEPARATION_STARTED: 2,
  WAITING_BREAK_RESOLUTION: 3,
  SEPARATION_COMPLETED: 4,
  PACKING_STARTED: 5,
  PACKING_COMPLETED: 6,
  SENT_TO_BILLING: 7,
  PICKING_STARTED: 8,
  DISPATCHED: 9,
  CANCELLED: 10,
  QUARANTINE: 11,
  IMPORTED_TYPED: 12,
  SERVICE_NOT_CONTRACTED: SERVICE_NOT_CONTRACTED_CODE,
};

export const getWMSStatusLabel = code => {
  switch (code) {
    case wmsStatus.DISPATCHED:
      return 'Expedido';
    case wmsStatus.CANCELLED:
      return 'Cancelado';
    case wmsStatus.QUARANTINE:
      return 'Quarentena';
    case wmsStatus.SERVICE_NOT_CONTRACTED:
      return 'Serviço não contratado';
    case wmsInCourseStatus.ID:
      return wmsInCourseStatus.LABEL;
    default:
      return '';
  }
};

export const isFinishedWMSStatus = code =>
  code === wmsStatus.DISPATCHED ||
  code === wmsStatus.CANCELLED ||
  code === wmsStatus.QUARANTINE;

export const getWMSStatusClass = code => {
  switch (code) {
    case wmsStatus.DISPATCHED:
      return 'dispatched';
    case wmsStatus.CANCELLED:
      return 'cancelled';
    case wmsStatus.QUARANTINE:
      return 'quarantine';
    case wmsStatus.SERVICE_NOT_CONTRACTED:
      return 'service-not-found';
    default:
      return '';
  }
};

export const getWMSStatusIcon = code => {
  switch (code) {
    case wmsStatus.DISPATCHED:
      return 'check_circle_checked';
    case wmsStatus.QUARANTINE:
      return 'warning';
    case wmsStatus.CANCELLED:
      return 'cancel';
    default:
      return '';
  }
};

// In Course WMS

export const wmsInCourseStatus = {
  ID: 'in-course-status-wms',
  LABEL: 'Em andamento',
  GROUP: [
    wmsStatus.WAITING_WAVE,
    wmsStatus.WAITING_SEPARATION,
    wmsStatus.SEPARATION_STARTED,
    wmsStatus.WAITING_BREAK_RESOLUTION,
    wmsStatus.SEPARATION_COMPLETED,
    wmsStatus.PACKING_STARTED,
    wmsStatus.PACKING_COMPLETED,
    wmsStatus.SENT_TO_BILLING,
    wmsStatus.PICKING_STARTED,
    wmsStatus.IMPORTED_TYPED,
  ],
};

// TMS Status

export const tmsStatus = {
  IN_DELIVERY: 0,
  DELIVERED: 1,
  TRANSFER_DELIVERY: 2,
  CONSOLIDATION: 3,
  SCHEDULED_DELIVERY: 4,
  PARIALLY_DELIVERED: 5,
  REJECTED: 6,
  SEPARATION: 7,
  SHIPPING_COMPANY_DELIVERY: 8,
  CANCELLED: 97,
  WAITING_NF_ENTRY: 98,
  SERVICE_NOT_CONTRACTED: SERVICE_NOT_CONTRACTED_CODE,
};

export const getTMSStatusLabel = code => {
  switch (code) {
    case tmsStatus.DELIVERED:
      return 'Entregue';
    case tmsStatus.TRANSFER_DELIVERY:
      return 'Entrega de transferência';
    case tmsStatus.SCHEDULED_DELIVERY:
      return 'Entrega agendada';
    case tmsStatus.PARIALLY_DELIVERED:
      return 'Entrega parcial';
    case tmsStatus.REJECTED:
      return 'Recusa total';
    case tmsStatus.CANCELLED:
      return 'Cancelado';
    case tmsStatus.SERVICE_NOT_CONTRACTED:
      return 'Serviço não contratado';
    case tmsInCourseStatus.ID:
      return tmsInCourseStatus.LABEL;
    default:
      return '';
  }
};

export const isFinishedTMSStatus = code =>
  code === tmsStatus.DELIVERED ||
  code === tmsStatus.TRANSFER_DELIVERY ||
  code === tmsStatus.SCHEDULED_DELIVERY ||
  code === tmsStatus.PARIALLY_DELIVERED ||
  code === tmsStatus.REJECTED ||
  code === tmsStatus.CANCELLED;

export const getTMSStatusClass = code => {
  switch (code) {
    case tmsStatus.DELIVERED:
      return 'delivered';
    case tmsStatus.TRANSFER_DELIVERY:
      return 'transfer-delivery';
    case tmsStatus.SCHEDULED_DELIVERY:
      return 'scheduled-delivery';
    case tmsStatus.PARIALLY_DELIVERED:
      return 'partially-delivered';
    case tmsStatus.REJECTED:
      return 'rejected';
    case tmsStatus.CANCELLED:
      return 'cancelled';
    case tmsStatus.SERVICE_NOT_CONTRACTED:
      return 'service-not-found';
    default:
      return '';
  }
};

export const getTMSStatusIcon = code => {
  switch (code) {
    case tmsStatus.DELIVERED:
    case tmsStatus.TRANSFER_DELIVERY:
    case tmsStatus.SCHEDULED_DELIVERY:
      return 'check_circle_checked';
    case tmsStatus.PARIALLY_DELIVERED:
      return 'delivered_partial';
    case tmsStatus.REJECTED:
      return 'error2';
    case tmsStatus.CANCELLED:
      return 'cancel';
    default:
      return '';
  }
};

// In Course TMS

export const tmsInCourseStatus = {
  ID: 'in-course-status-tms',
  LABEL: 'Em andamento',
  GROUP: [
    tmsStatus.IN_DELIVERY,
    tmsStatus.CONSOLIDATION,
    tmsStatus.SEPARATION,
    tmsStatus.SHIPPING_COMPANY_DELIVERY,
    tmsStatus.WAITING_NF_ENTRY,
  ],
};
